export interface CompanySettings {
  isHRISProviderUKG: boolean;
  autoDeleteVideoAfterAnalysis?: boolean;
  hideInsightEvidenceQuotes?: boolean;
  meetingDataPolicyLocked?: boolean;
}

export interface CompanySettingsRaw {
  hris_provider: HRIS_PROVIDER | null;
  auto_delete_video_after_analysis?: boolean;
  hide_insight_evidence_quotes?: boolean;
  meeting_data_policy_locked?: boolean;
}

export enum HRIS_PROVIDER {
  UKG = 'UKG',
}
